<template>
    <div class="componentWrapper">
        <b-container fluid :style="'height: ' + outerHeight+ 'px;'">
            <b-row style="height:4%;" class="d-flex align-items-center justify-content-center">
                <b-col style="padding-left:0px;">
                    <slot name="menu"></slot>
                </b-col>
            </b-row>

            <b-row :style="'height:96%;'" id="scrollableMainContent">
                <b-col :xs="12" :sm="12" :md="12" :lg="6" xl="4" :style="'padding:0 0;height: ' + innerHeight + 'px;overflow-y:auto'"
                    :class="[
                        {'col-lg-12': fullscreen, 'col-lg-6': !fullscreen},
                        {'col-xl-12': fullscreen, 'col-xl-4': !fullscreen},
                    ]"
                >
                    <slot name="grid"></slot>
                </b-col>
                <b-col :xs="12" :sm="12" :md="12" :lg="6" xl="8" style="height:auto;border:0px dashed red;"
                    :class="[
                            {'col-lg-12': fullscreen, 'col-lg-6': !fullscreen},
                            {'col-xl-12': fullscreen, 'col-xl-8': !fullscreen},
                            {'d-none': fullscreen, 'd-block': !fullscreen},
                        ]"
                    :style="[
                            {'visibility: hidden;' : fullscreen, 'visibility: visible;' : !fullscreen},
                            {'opacity: 0;' : fullscreen, 'opacity: 1;': !fullscreen}
                        ]"
                >
                    <slot name="form" v-if="!hasFormTabsSlot"></slot>

                    <b-row v-if="hasFormTabsSlot" style="padding:0 0; border:0px solid red;overflow-y:hidden" :style="'height: ' + innerHeight + 'px;'">
                        <b-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" style="border:0px dashed blue;height:auto" >
                            <slot name="formTabs" ></slot>
                        </b-col>
                    </b-row>
                </b-col> 
            </b-row>
        </b-container>
    </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default{
    name: "viewPage",
    props : {
        fullscreen: {
            type: [Boolean, String],
            required: false,
            default: false
        }, 
    },
    components: {


    },
    data() {
        return{
            maxHeight : 0,
            maxWidth : 0
        }
    },
    methods: {
        setScreenSize() {
            this.maxHeight = this.getScreenSize.height - 70//La hauteur visible moins la hauteur de la navigation
            this.maxWidth = this.getScreenSize.width
        },
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTheme', 'getScreenSize', 'getCheckSize', 'getAllSize']),
        outerHeight(){
            return this.getScreenSize.height
        },
        innerHeight(){
            return  (this.maxHeight - 30)
        },
        hasFormTabsSlot() {
            return !!this.$scopedSlots['formTabs'];
        }
        
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.setScreenSize()
    },
    updated() {
        this.setScreenSize()
    },
//------------------------------------------------------------------------------------------------
    watch: {
        
    }
}
</script>

<style lang="scss" scoped>
    .componentWrapper{
        padding:0px 1px 0px 1px;
        overflow: hidden;
        height:auto;
        border:0px solid green
    }
    #scrollableMainContent{
        //overflow: auto;
        overflow: hidden;
        border:0px dashed blue;
    }
</style>